import { render } from "./AnnoncementIcon.vue?vue&type=template&id=7b71acd8"
import script from "./AnnoncementIcon.vue?vue&type=script&lang=js"
export * from "./AnnoncementIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__